import theme from '../../../lib/theme';
import { CarouselProps } from './Carousel';

const {
  layouts,
  colors,
  scale,
  media,
  font: { families, heights, spacings, ...font },
} = theme;

export default ({
  brand = 'sas',
}: CarouselProps) => ({
  carousel: {
    overflow: 'hidden',
    marginBottom: brand == 'sas' ? 30 : 0,
  },
  inner: {
    whiteSpace: 'nowrap',
    width: '100vw',
    // transition: 'transform 0.3s',
  },
  carouselItem: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    color: '#fff',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    position: 'relative',
    overflow: 'hidden',
    [media.s.down]: {
      height: 400,
    },
  },
  newsImage: {
    position: 'absolute',
    filter: 'blur(150px)',
    transform: 'scale(3)',
  },
  slideImage: {
    position: 'absolute',
  },
  indicators: {
    display: 'flex',
    justifyContent: brand == 'travel360' ? 'center' : 'end',
    marginTop: brand == 'travel360' ? 10 : 30,
  },

  indicator: {
    height: 8,
    width: 50,
    background: 'rgba(101, 31, 255, 0.25)',
    border: 0,
    borderRadius: scale.s,
    marginRight: scale.xxs,
  },
  active: {
    backgroundColor: colors.sas.primary,
  },
});
